// extracted by mini-css-extract-plugin
module.exports =  {"counter-container":"dHKwzoX","counterContainer":"dHKwzoX","counter":"rS3LgX4"};